import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

interface filterState {
  value: ExitSlipFilter;
}

export interface ExitSlipFilter {
  roadmap: string;
  unit: string;
  classes: string[];
}
export const exitSlipInitialState: filterState = {
  value: {
    roadmap: '',
    unit: '',
    classes: [],
  },
};

export const filterExitSlipSlice = createSlice({
  name: 'exitSlipFilter',
  initialState: exitSlipInitialState,
  reducers: {
    setExitSlipFilter: (state, action: PayloadAction<ExitSlipFilter>) => {
      state.value = action?.payload;
    },
  },
});

export const selectedExitSlipFilter = (state: RootState) => state?.exitSlip?.value;

export const { setExitSlipFilter } = filterExitSlipSlice.actions;

export default filterExitSlipSlice.reducer;
